import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text2XL, textXS } from '@styles/fonts'
import styled, { keyframes } from 'styled-components'

export const Group = styled.div`
  margin-bottom: 52px;

  &:last-child {
    margin-bottom: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      border-right: 1px solid ${COLORS.grey[20]};
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        width: 140px;
        border-right: none;
      }
    }

    th {
      color: ${COLORS.cobalt.base};
      font-family: ${FONTS.medium};
      text-align: left;
      padding: 0 16px 16px;
    }

    td {
      padding: 10px 16px;
    }
  }
`

export const TableResonsive = styled.div`
  overflow-x: auto;
  padding-top: 12px;

  span {
    &:first-child {
      display: inline-block;
      width: 130px;
    }
    &:last-child {
      color: ${COLORS.cobalt.base};
    }
  }

  @media ${DEVICES.mobile} {
    margin-bottom: 32px;

    table thead tr th {
      padding: 8px 10px;

      &:nth-child(1) {
        width: 18%;
        padding-right: 0;
      }
      &:nth-child(2) {
        width: 20%;
      }
    }

    table tbody tr td {
      padding: 8px 10px;
      &:nth-child(1) {
        padding-right: 0;
        width: 18%;
      }
      &:nth-child(2) {
        width: 20%;
      }
    }
    thead tr th:last-child,
    tbody tr td:last-child {
      border-right: none;
    }
  }
`

export const GroupHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  > div {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media ${DEVICES.mobile} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
`

export const Title = styled.h2`
  ${text2XL};
  color: ${COLORS.suburbHeading};

  @media ${DEVICES.mobile} {
    text-align: center;
    margin: 0 auto;
  }
`

export const Description = styled.p``

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 28px;
`

const grow = (width) => keyframes`
  from { width: 0; }
  to { width: ${width}%; }
`

export const BarRow = styled.div``

export const BarLabel = styled.span`
  position: relative;
  z-index: 2;
  color: white;
  padding-left: 20px;
  display: inline-block;
  white-space: nowrap;
`

export const Bar = styled.div`
  background: ${(props) =>
    props.highlight ? COLORS.primary : COLORS.secondary};
  border-radius: 50px;
  height: 36px;
  width: 0; /* Start at zero width */
  animation: ${(props) => grow(props.width)} 0.5s ease-out forwards;
  animation-delay: ${({ index }) => index * 0.1}s;
  display: flex;
  align-items: center;
  overflow: hidden;

  @media ${DEVICES.mobile} {
    ${BarLabel} {
      ${textXS};
      padding-left: 16px;
    }
  }
`

export const Divider = styled.hr`
  display: none;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;

  @media ${DEVICES.mobile} {
    display: block;
  }
`
